
$(document).ready(function(){
  if($(window).width() > 768) return;
  var fakeAccordionTitles = [...$('.main-footer .footer-item--menus .footer-item__title.mobile')];
  if(fakeAccordionTitles.length == 0) return;
  function closeAllAccordions() {
    $('.main-footer .footer-item--menus .footer-item__title.mobile').removeClass('expanded');
    $('.main-footer .footer-item--menus .footer-links.mobile').slideUp().removeClass('open');
  }
  $.each(fakeAccordionTitles, function(i, title){
    $(title).on('click', function(){
      var f_links = $(this).parent().find('.footer-links');
      if($(this).hasClass('expanded')){
        closeAllAccordions();
        return;
      }
      closeAllAccordions();
      $(this).toggleClass('expanded');
      f_links.slideToggle();
      f_links.toggleClass('open');
    })
  })
})

$(document).ready(function(){
  var size_tables = $('.product-sizes-modal').find('table');
  $.each(size_tables, function(i, table){
    var tp = $(table).parent();
    if(tp.is('div')){
      if(!tp.hasClass('table-responsive')){
        tp.addClass('table-responsive');
      }
    } else {
      $(table).wrap('<div class="table-responsive"></div>');
    }
  })
})

function printStars(average, container){
	var stars = '';
	for (var i = 1; i<=average; ++i ){
		stars += '<i class="fa fa-star fa-lg"></i>';
		//stars += '<i class="fa fa-sharp fa-solid fa-star fa-2xs '+size+'"></i>';
	}
	if (i-0.5 == average) {
		stars += '<i class="fa fa-star-half-o fa-lg"></i>';
		//stars += '<i class="fa fa-sharp fa-solid fa-star-half-stroke fa-2xs '+size+'"></i>';
		++i;
	}
	for (j = i; j <= 5; ++j) {
		stars += '<i class="fa fa-star-o fa-lg"></i>';
		//stars += '<i class="fa fa-sharp fa-regular fa-star fa-2xs '+size+'"></i>';
	}
	container.html(stars);
}

$(document).ready(function(){
  var reviews = [...$('.custom-slick .content')];
  $.each(reviews, function(i, review){
    var container = $(review).find('.stars');
    var avrg = $(container).attr('data-value');
    printStars(parseInt(avrg), container);
  })
})







 

 
$(document).ready(function() {
    function setTopPosition() {
        var el = $('#section-collection-header2');
        if (el.length == 0) return;            
        var ww = parseInt($(window).width());
        if (ww <= 576) {
            $(el).css('top', '60px');
        } else if (ww > 576 && ww < 991) {
            $(el).css('top', '55px');
        } else if (ww >= 991 && ww < 1200) {
            $(el).css('top', '60px');
        } else {
            $(el).css('top', '91px');
        }
    }
    setTopPosition();
    $(window).resize(function() {
        setTopPosition();
    });
});



$(document).ready(function(){
  $('#collection-filters-handle').on('click', function(){
    $('#section-collection-header2').removeClass('position-sticky');
  })
  $('.sidebar__close').on('click', function(){
    $('#section-collection-header2').addClass('position-sticky');
  })
  $('.page-overlay').on('click', function(){
    if($(this).is(':visible') && $(this).css('visibility') !== 'hidden') {
      $('#section-collection-header2').addClass('position-sticky');
    }
  })
})

